<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-quote-left</v-icon>
        <h1 class="title ml-2">Pensamiento del día</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" class="mr-2" @click="showNew = true">
              <v-icon left>fas fa-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn-toggle rounded>
              <v-btn @click="prev()">
                <v-icon left>fas fa-arrow-left</v-icon>
                Anterior
              </v-btn>
              <v-btn @click="next()">
                Siguiente
                <v-icon right>fas fa-arrow-right</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Pesamiento</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pensamientos" :key="item.id">
                <td>{{item.fecha}}</td>
                <td class="text-truncate max-width-400">{{item.pensamiento}}</td>
                <td class="min-width-120">
                  <v-btn small fab text color="primary" @click="showItem(item)">
                    <v-icon>fas fa-list</v-icon>
                  </v-btn>
                  <v-btn small fab text color="secondary" @click="editItem(item)">
                    <v-icon>fas fa-edit</v-icon>
                  </v-btn>
                  <v-btn small fab text color="error" @click="deleteItem(item.id)">
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <!-- ------------------------------------------------------------------- -->
    <!-- new pensamiento -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showNew" max-width="600">
      <edit-pensamiento
        title="Agregar pensamiento de día"
        icon="fas fa-plus"
        v-model="pensamientoNew"
        @close="showNew = false"
        @save="savePensamiento()"
        ref="newPensamiento"
      ></edit-pensamiento>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- edit pensamiento -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showEdit" max-width="600">
      <edit-pensamiento
        title="Editar pensamiento de día"
        icon="fas fa-edit"
        v-model="pensamientoEdit"
        @close="showEdit = false"
        @save="updatePensamiento()"
      ></edit-pensamiento>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- show pensamiento -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showDetail" max-width="600">
      <show-pensamiento
        v-model="pensamientoShow"
        @close="showDetail = false"
      ></show-pensamiento>
    </v-dialog>
  </v-container>
</template>

<script>
import EditPensamiento from '../components/EditPensamiento'
import ShowPensamiento from '../components/ShowPensamiento'
import dayjs from 'dayjs'
export default {
  data () {
    return {
      pensamientos: [],
      showEdit: false,
      showDetail: false,
      showNew: false,
      pensamientoShow: null,
      pensamientoEdit: null,
      pensamientoNew: {
        fecha: '',
        pensamiento: ''
      },
      page: 0
    }
  },
  computed: {
    url () {
      return `?_start=${this.page * 20}&_limit=20&_sort=fecha:DESC`
    }
  },
  components: {
    EditPensamiento,
    ShowPensamiento
  },
  methods: {
    showItem (item) {
      this.pensamientoShow = item
      this.showDetail = true
    },
    editItem (item) {
      this.pensamientoEdit = item
      this.showEdit = true
    },
    savePensamiento () {
      this.$http.pensamientos
        .post('', this.pensamientoNew)
        .then(() => {
          this.getPensamientos()
          this.$refs['newPensamiento'].reset()
          this.showNew = false
        })
    },
    getPensamientos () {
      this.$http.pensamientos
        .get(this.url)
        .then(res => res.data)
        .then(res => {
          res.forEach(i => {
            i.fecha = dayjs(i.fecha).add(1, 'd').format('YYYY-MM-DD')
          })
          this.pensamientos = res
        })
    },
    updatePensamiento () {
      this.$http.pensamientos
        .put(`/${this.pensamientoEdit.id}`, this.pensamientoEdit)
        .then(() => {
          this.getPensamientos()
          this.showEdit = false
        })
    },
    deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        this.$http.pensamientos
          .delete(`/${id}`)
          .then(() => {
            this.getPensamientos()
          })
      }
    },
    next () {
      if (this.pensamientos.length) {
        this.page = this.page + 1
      }
    },
    prev () {
      if (this.page > 0) {
        this.page = this.page - 1
      }
    }
  },
  mounted () {
    this.getPensamientos()
  },
  watch: {
    page () {
      this.getPensamientos()
    }
  }
}
</script>
